







import { Component, Vue } from "vue-property-decorator";
import { PESAN_VERIFIKASI_TERKUNCI } from "@/utility/PemeriksaanReadonly";

@Component({
  inject: {
    verifikasiTerkunciFn: {
      from: "isVerifikasiTerkunci",
      default: () => () => false
    }
  }
})
export default class VerifikasiTerkunciHint extends Vue {
  verifikasiTerkunciFn!: () => boolean;

  pesan = PESAN_VERIFIKASI_TERKUNCI;

  get terkunci(): boolean {
    return this.verifikasiTerkunciFn();
  }
}
